import {ChangeDetectionStrategy, Component, inject, input, OnInit} from '@angular/core';
import {ProductCompositionsModalService} from "../../services/product-compositions-modal.service";
import {ProductCompositionFilesStateService} from "../../services/product-composition-files-state.service";
import {LoadingService} from "../../../../../../../../core/services/loading.service";
import {ProductCompositionsFile} from "../../types/product-compositions-modal.types";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {productCompositionFilesResourceType} from "../../configs/product-compositions-modal-config";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-product-compositions-files]',
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './product-compositions-files.component.html',
  styleUrl: './product-compositions-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCompositionsFilesComponent implements OnInit {
  productCompositionId = input<number>(0);
  isEditModeActive = input<boolean>(false);

  private productCompositionsModalService: ProductCompositionsModalService = inject(ProductCompositionsModalService);
  private productCompositionFilesStateService: ProductCompositionFilesStateService = inject(ProductCompositionFilesStateService);
  private loadingService: LoadingService = inject(LoadingService);

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<ProductCompositionsFile> {
    return this.productCompositionFilesStateService.getProductCompositionFilesById(this.productCompositionId());
  }

  public async handleDelete(isImage: boolean, file: ProductCompositionsFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: productCompositionFilesResourceType.path,
      id: file.id
    };

    this.productCompositionsModalService.deleteFile(deleteFileParams)
      .then(() => this.productCompositionFilesStateService.deleteFileById(file.id, this.productCompositionId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: productCompositionFilesResourceType.path,
      body: {
        fileId: fileId,
        productCompositionId: parentId
      }
    };

    await this.productCompositionsModalService.attachFile<ProductCompositionsFile>(attachFileParams)
      .then((data) => this.productCompositionFilesStateService.updateProductCompositionFilesState(this.productCompositionId(), data));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: GetFilesParams = {
      path: productCompositionFilesResourceType.path,
      params: { productCompositionId: this.productCompositionId() }
    };

    await this.productCompositionsModalService.getFiles(params)
      .then((data) => this.productCompositionFilesStateService.setProductCompositionFilesState(this.productCompositionId(), data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
